// 전역 상수
export default Object.freeze({
  /** UPLOAD COMPONENT 재조회 컬럼 PREFIX */
  UPLOAD_RESEARCH_COL: "uprecol",
})